import moment from "moment";
import React, { useState, useEffect } from "react";
import { Line } from "react-chartjs-2";
import { useTranslation } from "react-i18next";

const DashboardChart = ({ data, loading }) => {
  const [state, setState] = useState(null);
  const { t } = useTranslation();

  const getChartData = () => {
    let labels = [];
    let dataBilan = [];
    for (let i = 0; i <= data.length; i++) {
      if (data[i] && data[i].dates) {
        let allDate = data[i].dates;
        let date = moment(allDate).locale("En").format("MMM DD");
        labels.push(date);
        dataBilan.push(parseFloat(data[i].bilan).toFixed(2));
      }
    }
    const state = {
      labels: labels,
      datasets: [
        {
          label: `${t("water_balance")}`,
          fill: false,
          lineTension: 0.5,
          backgroundColor: "rgba(75,192,192,1)",
          borderColor: "#26a6b7",
          borderWidth: 2,
          data: dataBilan,
        },
      ],
    };
    setState(state);
  };

  useEffect(() => {
    getChartData();
  }, [data]);

  if (loading) {
    return (
      <div className="simulation-dashboard-chart-loading">
        <span className="simulation-dashboard-skeleton" aria-hidden="true" />
        <span>{t("loading")}</span>
      </div>
    );
  }

  if (!state || state.labels.length === 0) {
    return (
      <div className="simulation-dashboard-chart-empty">
        <i className="material-icons" aria-hidden="true">&#xe614;</i>
        <span>{t("no_simulation_data", "No simulation data to display yet.")}</span>
      </div>
    );
  }

  return (
    <Line
      data={state}
      options={{
        plugins: {
          title: {
            display: true,
            text: `${t("water_balance")}`,
            font: {
              size: 20,
            },
          },
          legend: {
            display: true,
            position: "right",
          },
        },
        scales: {
          x: {
            ticks: {
              padding: 2,
            },
          },
        },
      }}
    />
  );
};

export default DashboardChart;
